function load(component) {
    return () =>import (`@/components/${component}.vue`);
};
export default{
    path: "/info",
    component: load("dashboard"),
    children: [
        {
            path: "",
            name: "client",
            component: load("info/Client"),
            meta: {
                parent: 'information',
                child: 'client',
                deal: false
            }
        },
        {
            path: "client",
            name: "create-client",
            component: load("info/CreateClient"),
            meta: {
                parent: 'information',
                child: 'client',
                deal: true
            }
        },
        {
            path: "client-info/:id",
            name: "client-info",
            component: load("info/ClientInfo"),
            meta: {
                parent: 'information',
                child: 'client',
                deal: false
            }
        },
        {
            path: "supplier",
            name: "supplier",
            component: load("info/Supplier"),
            meta: {
                parent: 'information',
                child: 'agency',
                deal: false
            }
        },
        {
            path: "create-supplier",
            name: "create-supplier",
            component: load("info/CreateSupplier"),
            meta: {
                parent: 'information',
                child: 'agency',
                deal: true
            }
        },
        {
            path: "supplier-info/:id",
            name: "supplier-info",
            component: load("info/SupplierInfo"),
            meta: {
                parent: 'information',
                child: 'agency',
                deal: false
            }
        }
    ]

}



// WEBPACK FOOTER //
// ./src/router/info.js